import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function ButtonDisable({ buttonTagHtml }) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <p className="m-0" style={{ fontFamily: "IRANSansWeb" }}>
        این دکمه در نسخه آموزشی کار نمی کند
      </p>
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      {buttonTagHtml}
    </OverlayTrigger>
  );
}
